module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('suggest', {
    attrs: {
      "suggestions": _vm.suggestions,
      "inputProps": _vm.inputProps,
      "getSuggestionValue": _vm.getSuggestionValue,
      "renderSuggestion": _vm.renderSuggestion
    },
    on: {
      "selected": _vm.selectHandler
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d683092"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/searchClients.vue
// module id = 508
// module chunks = 1